import React, { useContext } from 'react'
import { FormContext } from '../FormContext';
import { Col } from "react-bootstrap";
import Select from "react-select";
import "./customelements.css"

const CustomSelect = ({ id, label, placeholder, value, options, disabled, mandatory, md }) => {
    const { handleChange } = useContext(FormContext)

    return (
        <Col md={md} className="pad-trbl-10 custom-select-holder">
            <label className="form-label move-left">{mandatory?<span style={{color:"red", marginRight: 5}}>*</span>:""}{label}</label>
            <Select
                  placeholder={"Select "}
                  defaultValue={options[0]}
                  value={value}
                  onChange={event => handleChange(id, event)}
                  options={options}
                  className='custom-select'
                  classNamePrefix="react-select"
                  isDisabled={disabled}
                  required={mandatory}
                />
            {/* <select className="form-select move-left custom-select" 
                    aria-label="Default select example"
                    onChange={event => handleChange(id, event)}
            >
                <option disabled selected hidden>{placeholder}</option>
                {options.length > 0 && options.map((option, i) =>
                    <option value={option.value} key={i} className="custom-option">{option.label}</option>

                )}
            </select> */}
        </Col>
    )
}

export default CustomSelect